module.exports = __webpack_public_path__ + "static/media/dealiem-logo-combined.269e9f7a.svg";